import { cx } from '@/utils/cx';
import styles from './ScanlineOverlay.module.css';

export interface ScanlineOverlayProps {
  flicker?: boolean;
}

export function ScanlineOverlay({ flicker = true }: ScanlineOverlayProps) {
  return (
    <div
      aria-hidden="true"
      data-testid="scanline-overlay"
      className={cx(styles.overlay, flicker && styles.flicker)}
    />
  );
}
